// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(max-width:991px){.main-container[data-v-e6bc3320]{padding-left:3rem;padding-right:3rem}}@media(max-width:575px){.main-container[data-v-e6bc3320]{padding-left:1.5rem;padding-right:1.5rem}}.logo[data-v-e6bc3320]{width:150px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
